const mentionStyle = {
  backgroundColor: "#cee4e5",
  color: "blue",
};

export default mentionStyle;
